import Vue from 'vue';
import { mapGetters } from 'vuex';
import vSelect from 'vue-select';
import { guid } from '@/mixins/guid';
import { dynamicSetup } from '@/mixins/dynamic-setup';
import { siteBuilder } from '@/mixins/site-builder';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('data-product-store-discounts', {
  template: require('./template.html'),
  name: 'data-product-store-discounts',
  computed: {
    ...mapGetters([
      'currentSite',
      'activeSiteType',
    ]),
    storeData() {
      return this.currentSite.dynamic.products;
    },
  },
  mixins: [guid, dynamicSetup, siteBuilder],
  components: {
    vSelect,
    dropsLoader,
  },
  data() {
    return {
      loading: false,
      storewide: 0,
      initialEdits: {
        storewide: null,
      },
    };
  },
  props: [
    'item-modal',
    'content',
    'active-item',
    'item-list',
    'all-categories',
  ],
  created() {
    if (this.noDynamicData(this.activeSiteType)) {
      this.dynamicSetup(this.activeSiteType);
    }
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      const { discounts = {} } = this.storeData;
      this.storewide = discounts.storeWide || 0;
      this.initialEdits.storewide = this.storewide;
    },
    saveChanges() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          const notif = {
            id: this.guid(),
            type: 'success',
            time: 2000,
            message: 'Store discounts saved!',
          };
          try {
            const { dynamic, _id } = this.currentSite;
            const value = this.storewide;
            if (!dynamic.products.discounts) {
              this.$store.dispatch('setGlobalValue', {
                item: dynamic.products,
                key: 'discounts',
                value: {
                  storeWide: 0,
                  conditions: [],
                  codes: [],
                },
              });
            }
            this.$store.dispatch('setGlobalValue', {
              item: dynamic.products.discounts,
              key: 'storeWide',
              value,
            });
            await this.$lightning([{
              name: 'updateDynamic',
              payload: {
                siteId: _id,
                attr: 'products.discounts',
                value: dynamic.products.discounts,
              },
            }]);
            // we also need to regenerate the site in this instance
            await this.callBuilder({
              publish: 'site',
              site: {
                _id: this.currentSite._id,
              },
            });
            this.$store.dispatch('setPublishItem', {
              type: this.activeSiteType,
              stamp: new Date().toISOString(),
            });
            this.initialEdits.storewide = this.storewide;
          } catch (e) {
            this.$log.error(e.message || e);
            notif.type = 'error';
            notif.message = e.message || e;
            await this._reportError({
              error: e,
              fn: 'saveChanges store discounts',
            });
          } finally {
            this.loading = false;
            this.$store.dispatch('addNotification', notif);
          }
        }
      });
    },
    cancelChanges() {
      this.storewide = this.initialEdits.storewide;
      const { discounts } = this.storeData;
      if (discounts) {
        this.$store.dispatch('setGlobalValue', {
          item: discounts,
          key: 'storeWide',
          value: this._getInputVal(this.storewide),
        });
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/store/discounts/index.js